import React, { useEffect, useState } from 'react';
import axios from 'axios';
import apiConstants from '../../../constans/apiConstants';
import { httpRequestGet, toaster } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, Card } from 'react-bootstrap';
const ProposalLogs = (props) => {
    const { proposal } = props
    const [initialdata, logList] = useState([]);
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch({ type: 'LOADER_TRUE' });
        axios.get(
            `${apiConstants().BAXA_API_URL}s3-details/${proposal}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                },
            }
        ).then((res) => {
            dispatch({ type: 'LOADER_FALSE' })
            if (res && res.data) {
                const sortedDesc = res.data?.body?.sort((a, b) => {
                    const tsA = parseInt(a.match(/_(\d+)\.json$/)[1]);
                    const tsB = parseInt(b.match(/_(\d+)\.json$/)[1]);
                    return tsB - tsA; // descending
                    });
                logList(sortedDesc)
            }
        }).catch((err) => {
            dispatch({ type: 'LOADER_FALSE' });
            if (err && err.data) {
                toaster('error', err.data.message)
            }
        });
    }, [proposal])
    const downloadData = (downloadLink) => {
        const item = downloadLink.split("/")
        const path = `${apiConstants().BAXA_API_URL}download/${proposal}?file=${item && item[1]}`;
        dispatch({ type: 'LOADER_TRUE' });
        httpRequestGet(path).then((res) => {
            dispatch({ type: 'LOADER_FALSE' })
            if (res && res.data) {
                setData(res.data.body)
                const response = res.data
                const a = document.createElement('a');
                const type = "json";
                let fD;
                // if('jsonRequest' in response) {
                //     const parsedData = JSON.parse(response['jsonRequest']);
                //     delete response['jsonRequest'];
                //     fD = response;
                //     fD['jsonRequest'] = parsedData;
                //     fD = JSON.stringify(fD,null, 4);
                // } else {
                    fD=JSON.stringify(res.data, null, 4);
                // }
                a.href = URL.createObjectURL(new Blob([fD], { type: `text/${type === "txt" ? "plain" : type}` }));
                a.download = `${response.action}.json`;
                a.click();
                // toaster('success', res.data.message)
            }
        }).catch((err) => {
            dispatch({ type: 'LOADER_FALSE' });
            if (err && err.data) {
                toaster('error', err.data.message)
            }
        });
    }
    return (
        <div className="main_container">
            <Accordion flush>
                <Accordion>

                    {initialdata && initialdata.map((item, key) => {
                        return (
                            <Card>
                                {/* <Accordion.Toggle as={Card.Header} eventKey={key + 1}>
                                            {item.proposalNo}

                                        </Accordion.Toggle> */}
                                <div className= "proposalLogsLink" onClick={() => downloadData(item)}>{item.split("/")[1]}</div>
                                {/* <Accordion.Collapse eventKey={key + 1}>
                                            <div><pre>{JSON.stringify(item, null, 2)}</pre></div>
                                        </Accordion.Collapse> */}
                            </Card>
                        )
                    })}
                </Accordion>
            </Accordion>
        </div>
    )
}

export default ProposalLogs;
